import type { ReactElement } from "react";

import Svg, {
  ClipPath,
  Defs,
  G,
  Path,
  Rect,
} from "@/crossPlatform/react-native-svg";

const ProgressIllustrationSVG = ({
  height,
  width,
}: Partial<SizeDimensions>): ReactElement<Partial<SizeDimensions>, "svg"> => (
  <Svg fill="none" height={height} viewBox="0 0 240 240" width={width}>
    <G clipPath="url(#clip0_5102_19295)">
      <Path
        d="M139 56C177.66 56 209 87.3401 209 126L209 234C209 237.314 206.314 240 203 240L38 240C26.9543 240 18 231.046 18 220L18 120C18 84.6538 46.6538 56 82 56L139 56Z"
        fill="#FFE7A9"
      />
      <G clipPath="url(#clip1_5102_19295)">
        <Path
          d="M48.8683 132.846C75.3835 136.593 102.604 130.304 125.909 117.408C148.861 104.71 167.758 85.4091 181.871 63.409C189.933 50.846 196.549 37.3563 201.815 23.3898C202.793 20.7854 202.829 17.3713 201.604 14.8344C200.607 12.7743 198.745 12.6214 197.878 14.9244C188.91 38.7282 175.865 61.0656 158.238 79.4851C140.368 98.1611 117.381 112.245 92.2165 118.398C77.9511 121.884 63.1247 122.802 48.572 120.746C45.2997 120.283 44.8822 132.283 48.8683 132.846Z"
          fill="#007F79"
        />
        <Path
          d="M162.525 33.5238C176.382 32.5567 189.92 28.5355 202.094 21.8333L199.05 19.1255C201.586 29.4261 203.75 39.8076 205.55 50.2611C205.806 51.7365 206.659 55.4924 208.894 54.4083C210.959 53.4053 210.851 48.6463 210.551 46.9236C208.584 35.5075 206.214 24.1588 203.445 12.9092C203.135 11.6587 202.049 9.29723 200.401 10.2013C188.605 16.6966 175.65 20.4839 162.224 21.424C158.445 21.6894 158.894 33.7757 162.52 33.5238H162.525Z"
          fill="#007F79"
        />
        <Path
          d="M218.788 207.783H171.211C171.947 210.652 172.684 213.521 173.42 216.39V101.606C172.684 104.475 171.947 107.344 171.211 110.213H218.788C218.052 107.344 217.315 104.475 216.579 101.606V216.39C216.579 218.375 216.695 220.529 217.226 222.476C217.351 222.938 217.788 224.905 218.788 224.996C220.975 225.199 220.998 216.975 220.998 216.39V177.592C220.998 156.986 220.998 136.38 220.998 115.771C220.998 111.051 220.998 106.327 220.998 101.606C220.998 99.6174 220.877 97.4677 220.351 95.5207C220.181 94.8972 219.819 93 218.788 93H171.211C168.876 93 169.001 100.861 169.001 101.606V216.39C169.001 218.379 169.122 220.529 169.648 222.476C169.818 223.099 170.18 224.996 171.211 224.996H218.788C219.761 224.996 220.257 222.82 220.351 222.476C220.877 220.544 221.02 218.36 220.998 216.39C220.975 214.363 220.886 212.286 220.351 210.304C220.181 209.681 219.819 207.783 218.788 207.783Z"
          fill="#007F79"
        />
        <Path
          d="M157.788 207.847H110.211C110.947 210.705 111.684 213.563 112.42 216.421V142.575C111.684 145.433 110.947 148.291 110.211 151.15H157.788C157.052 148.291 156.315 145.433 155.579 142.575V216.421C155.579 218.399 155.695 220.545 156.226 222.485C156.351 222.946 156.788 224.905 157.788 224.996C159.975 225.198 159.998 217.005 159.998 216.421V142.575C159.998 140.593 159.877 138.451 159.351 136.511C159.181 135.89 158.819 134 157.788 134H110.211C107.876 134 108.001 141.832 108.001 142.575V216.421C108.001 218.403 108.122 220.545 108.648 222.485C108.818 223.106 109.18 224.996 110.211 224.996H157.788C158.761 224.996 159.257 222.828 159.351 222.485C159.877 220.56 160.02 218.384 159.998 216.421C159.975 214.402 159.886 212.332 159.351 210.358C159.181 209.737 158.819 207.847 157.788 207.847Z"
          fill="#007F79"
        />
        <Path
          d="M96.7458 207.78H48.2532C49.0038 210.649 49.7545 213.519 50.5051 216.388V175.608C49.7545 178.478 49.0038 181.347 48.2532 184.216H96.7458C95.9951 181.347 95.2445 178.478 94.4938 175.608V216.388C94.4938 218.374 94.6121 220.528 95.1535 222.475C95.2809 222.938 95.7267 224.904 96.7458 224.996C98.975 225.199 98.9978 216.973 98.9978 216.388V175.608C98.9978 173.619 98.8749 171.469 98.3381 169.521C98.1652 168.898 97.7967 167 96.7458 167H48.2532C45.8738 167 46.0012 174.862 46.0012 175.608V216.388C46.0012 218.378 46.124 220.528 46.6609 222.475C46.8337 223.099 47.2022 224.996 48.2532 224.996H96.7458C97.7376 224.996 98.2425 222.819 98.3381 222.475C98.8749 220.543 99.0205 218.358 98.9978 216.388C98.975 214.36 98.884 212.283 98.3381 210.301C98.1652 209.678 97.7967 207.78 96.7458 207.78Z"
          fill="#007F79"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="clip0_5102_19295">
        <Rect fill="white" height="240" width="240" />
      </ClipPath>
      <ClipPath id="clip1_5102_19295">
        <Rect
          fill="white"
          height="215"
          transform="translate(45 10)"
          width="176"
        />
      </ClipPath>
    </Defs>
  </Svg>
);

export default ProgressIllustrationSVG;
